<template>
  <b-modal
    id="modal-play-voice"
    ref="modalPlayVoice"
    size="md"
    :title="title"
    centered
    @hidden="handleHidden"
    data-me="rjm-component-modal-play-voice"
  >
    <div class="d-flex align-items-center mc-modal__play-voice">
      <audio
        ref="audioPlayer"
        :src="audioUrl"
        @timeupdate="updateProgress"
        @loadedmetadata="onLoadedMetadata"
        @ended="onEnded"
      ></audio>
      <div
        class="cursor-pointer mc-modal__play-voice-btn me-2"
        @click="togglePlay"
        data-me="rjm-component-modal-play-voice-button-toggle-play"
      >
        <i
          :class="isPlaying ? 'mc-fa icon-outline_pause-circle' : 'mc-fa icon-outline_play-circle'"
        ></i>
      </div>

      <span class="me-2">{{ formatTime(currentTime) }}</span>

      <div
        ref="progressBar"
        class="flex-grow-1 position-relative mc-modal__play-voice-progress"
        @click="seek"
        data-me="rjm-component-modal-play-voice-progress-bar"
      >
        <div
          :style="{ width: Math.min(progress, 100) + '%' }"
          class="mc-modal__play-voice-progress-main"
        ></div>
      </div>

      <span class="ms-2">{{ formatTime(duration) }}</span>

      <i class="mc-fa icon-fill_volume-up ms-2"></i>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn mt-0">
          <McButton
            variant="outline-primary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel()"
            data-me="rjm-component-modal-play-voice-button-close"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { getAudioFiles } from '@/services/api/master/rjm'

export default {
  name: 'ModalPlayVoice',
  components: {
    McButton,
  },
  data() {
    return {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      title: '',
      audioUrl: '',
    }
  },
  computed: {
    progress() {
      return this.duration ? (this.currentTime / this.duration) * 100 : 0
    },
  },
  methods: {
    async show(item) {
      if (typeof item === 'string') {
        this.audioUrl = item
        this.title = 'Play Audio'
      } else {
        this.title = item?.label || 'Play Audio'
        this.audioUrl = item?.audioFileUrl || ''

        // Jika audioUrl kosong tetapi ada audioFileId, coba ambil dari API
        if (!this.audioUrl && item?.audioFileId) {
          await this.fetchAudioFile(item.audioFileId)
        }
      }

      this.currentTime = 0
      this.isPlaying = false
      this.$refs.modalPlayVoice.show()
    },

    async fetchAudioFile(audioFileId) {
      try {
        const res = await this.$apollo.query({
          query: getAudioFiles,
          variables: {
            filter: {
              audioFileId: parseInt(audioFileId, 10),
            },
          },
          fetchPolicy: 'no-cache',
        })

        if (res.data.audioFiles.isSuccessful && res.data.audioFiles.audioFiles.data.length > 0) {
          const audioFile = res.data.audioFiles.audioFiles.data[0]
          this.audioUrl = audioFile.audioFileUrl
          this.title = audioFile.label
        }
      } catch (error) {
        console.error('Gagal mengambil data audio:', error)
      }
    },
    handleHidden() {
      this.pause()
      this.audioUrl = ''
      this.currentTime = 0
    },
    handleCancel() {
      this.$refs.modalPlayVoice.hide()
    },
    togglePlay() {
      if (this.isPlaying) {
        this.pause()
      } else {
        this.play()
      }
    },
    play() {
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.play()
        this.isPlaying = true
      }
    },
    pause() {
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.pause()
        this.isPlaying = false
      }
    },
    updateProgress() {
      if (this.$refs.audioPlayer) {
        this.currentTime = this.$refs.audioPlayer.currentTime
      }
    },
    onLoadedMetadata() {
      if (this.$refs.audioPlayer) {
        this.duration = this.$refs.audioPlayer.duration
      }
    },
    onEnded() {
      this.isPlaying = false
      this.currentTime = 0
    },
    formatTime(seconds) {
      if (isNaN(seconds)) return '00:00'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    seek(event) {
      if (!this.$refs.audioPlayer || !this.duration) return
      const progressBar = this.$refs.progressBar
      const rect = progressBar.getBoundingClientRect()
      const offsetX = event.clientX - rect.left
      const percentage = Math.max(0, Math.min(1, offsetX / rect.width))
      const seekTime = percentage * this.duration
      this.$refs.audioPlayer.currentTime = seekTime
      this.currentTime = seekTime
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-modal__play-voice {
  .mc-modal__play-voice-btn {
    font-size: 28px;
    color: $primary;
  }

  .icon-fill_volume-up {
    font-size: 21px;
    color: $primary;
  }
}

.mc-modal__play-voice-progress {
  height: 8px;
  background-color: $teal-100;
  border-radius: 4px;
  cursor: pointer;
}

.mc-modal__play-voice-progress-main {
  height: 100%;
  background-color: $primary;
  border-radius: 4px;
}
</style>
